import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { ExchangeWrapperComponent } from './exchange-wrapper.component';
import { PipesModule } from '../shared/pipes.module';

@NgModule({
  imports: [PipesModule],
  declarations: [ExchangeWrapperComponent],
  exports: [ExchangeWrapperComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA], // allow Exchange components to be used
})
export class ExchangeWrapperModule {}
